const myButtonStyles = {
  root: {}
};

export default myButtonStyles;
